import RootRequest from "./RootRequest";

export default class CarrierDriverRequest extends RootRequest {
  get apiResource() {
    return "api/carrier-driver";
  }
}

export const carrierDriverRequest = new CarrierDriverRequest();
